//画面サイズごとの処理
$(window).on('load resize', function(){
	const w = $(window).width();
	deviceFunc(w);
});
const browser=browserCheck();
const os=osCheck();
const device=deviceCheck();
$("body").addClass(browser).addClass(os);

const href=$(location).attr('href');
let host=	$(location).attr('hostname');
const ref=document.referrer;
const hash=$(location).attr('hash');

if(href.indexOf("/test/")>0)	{
	host=host + "/test";
}

$(document).ready(function(){
	
	
  // <a href="#***">の場合、スクロール処理を追加
  $('a[href*="#"]').click(function() {
		if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
  		let $target = jQuery(this.hash);
      $target = $target.length && $target || jQuery('[name="' + this.hash.slice(1) +'"]');
      if ($target.length) {
      	const targetOffset = $target.offset().top;
        $('html,body').animate({ scrollTop: targetOffset }, 800, 'easeOutExpo');//fast
        //$('html,body').animate({ scrollTop: targetOffset }, 1000, 'easeInOutQuart');//smooth
        /*$('html, body').animate({scrollTop: targetOffset/5,opacity: 0}, 300, function() {
					$('html, body').animate({opacity: 1,scrollTop: targetOffset}, 600);
				});//fade scroll*/
        return false;
      }
    }
  });
   
  
  //Menu
  $("#menu-btn").click(function(){
	  $("#menu").toggleClass("open");
  });
  $("#gnavi a").click(function(){
	  if($("#menu.open").length){
			$("#menu").removeClass("open");
		}
	});
  
  var hover;
	$('#gnavi .has-drop').hover(
	  function() {
		  hasdrop=$(this);
	    hover = setTimeout(function() {
	      hasdrop.addClass("hover");
	    }, 400);
	  }, function() {
		  hasdrop=$(this);
			hasdrop.removeClass("hover");
	    clearTimeout(hover);
	  }
	)
  
  //mailmz
  if($(".mailmz").length){
	  const mailmz_close=$.cookie("lw_mailmz_close");
	  //console.log(mailmz_close);
	  if(mailmz_close == 1){
		  $(".mailmz").css({"display":"none"});
	  }
	  $(".mailmz-close").on("click",function(){
			$(".mailmz").css({"display":"none"});
			$.cookie("lw_mailmz_close", 1, { expires: ""});
		});
  }
  
  if($("#key").length){
	  let touch = true;
	  if(browser=="chrome"){
		  touch = false;
	  }
		const key=$('.slide-body').bxSlider({
			speed:1200,
			easing:'cubic-bezier(.1,.82,.1,1)',
			pause:9000,
			auto:true,
			controls:false,
			touchEnabled:touch,
			onSliderLoad:function(index){
				$('.slide-body li').addClass("is-show");
			},
			onSlideBefore:function($slideElement, oldIndex, newIndex){
				index=oldIndex;
				//$('.slide-body li').eq(index+1).find(".key-title-box").removeClass("show");
			},
			onSlideAfter:function($slideElement, oldIndex, newIndex){
				//$slideElement.find(".key-title-box").addClass("show");
			}
		});
	}
  
  //inView
  $('.anm').on('inview', function(event, isInView) {
    if (isInView) {
    //表示領域に入った時
      $(this).addClass('is-show');
    } else {
    //表示領域から出た時
     	//$(this).removeClass('is-show');
    }
  });
  
  
  //scroll
  $(window).scroll(function () {
   	const body = window.document.body;
	 	const html = window.document.documentElement;
	 	const scrTop = body.scrollTop || html.scrollTop;
	 	const scrBottom = html.scrollHeight - html.clientHeight - scrTop;
	 	
	 	const footer_top=$("footer").offset().top;
	 	
	 	if($(".fixed-header").length){
		 	if(scrTop > 400){
				$(".fixed-header").addClass("is-show");
			}else{
				$(".fixed-header").removeClass("is-show");
			}
	 	}
	 	if(scrTop > 100){
		 	$(".mailmz").addClass("is-show");
	 	}else{
		 	$(".mailmz").removeClass("is-show");
	 	}
	 	
	 	/*if(scrTop + html.clientHeight > footer_top){
			$(".mailmz").addClass("is-show");
			
		}else{
			$(".mailmz").removeClass("is-show");
		}*/
		
  });
  
  
  //GoogleMapAPI
	if($("#gmap").length){
		const styles=[];
		googlemap({
				"wrapid" : "gmap",
				"tit" : "株式会社ライフワークス",
				"styles" : styles,
				"lat" : 35.6865275,
				"lng" : 139.7028382,
				"maplat" : 35.6865275, //mapの中心
				"maplng" : 139.7028382, //mapの中心
				"zoom" : 16,
				"infoshow" : false,
				"icon" : "https://" + host +"/common/images/gmap_marker.png",
				"iconw" : 50,
				"iconh" : 50
		});
	}
	
	//exValidation
	if($(".validationform").length){
		/*inputの下にエラー
		const validation = $(".validationform").exValidation({
			errInsertPos :"after",
			errPosition :"fixed",
		  stepValidation: true,
		  errHoverHide:false,
		  errTipCloseBtn:false,
		  scrollAdjust:0,
		  errMsgPrefix : ""
		});*/
		
		/*エラー吹き出し表示*/
		const validation = $(".validationform").exValidation({
		  stepValidation: true,
		  errHoverHide:true,
		  errTipCloseBtn:false,
		  scrollAdjust:0,
		  errMsgPrefix : ""
		});
	}
	

	if($(".service-case-tab-list").length){
		$(".service-case-tab-list .tab").on("click",function(){
			var tabNumber = $(this).index() + 1;
			$(".service-case-tab-list .tab").removeClass("active");
			$(this).addClass("active");

			$(".service-case-tab-box").removeClass("active");
			$(".service-case-tab-contents .tab" + tabNumber).addClass("active");
			
		});
	}
	//導入事例
	if($("#case").length){
		var ulList = document.getElementsByClassName('divisions-4');
		for (var i = 0; i < ulList.length; i++) {
			var listItems = ulList[i].getElementsByTagName('li');
			for (var j = 0; j < listItems.length; j++) {
				if ((j + 1) % 4 === 1) {
					listItems[j].classList.add('leftedge');
				}
			}
		}
		var ulList = document.getElementsByClassName('divisions-3');
		for (var i = 0; i < ulList.length; i++) {
			var listItems = ulList[i].getElementsByTagName('li');
			for (var j = 0; j < listItems.length; j++) {
				if ((j + 1) % 3 === 1) {
					listItems[j].classList.add('leftedge');
				}
			}
		}
	}
});
//導入事例
function openTab(evt, tabName) {
	var i, tabcontent, tabitem;

	tabcontent = document.getElementsByClassName("tab-content");
	for (i = 0; i < tabcontent.length; i++) {
		tabcontent[i].style.display = "none";
	}

	tabitem = document.getElementsByClassName("tab-item");
	for (i = 0; i < tabitem.length; i++) {
		if (tabitem[i].className.includes("active")) {
			tabitem[i].className = tabitem[i].className.replace(" active", "");
			if (tabitem[i].getAttribute("onclick") === "openTab(event, '" + tabName + "')") {
				document.getElementById(tabName).style.display = "none";
				return;
			}
		}
	}

	document.getElementById(tabName).style.display = "block";
	evt.currentTarget.className += " active";
}
function deviceFunc(w){
	const bp = [559,959,1280];
	if (w <= bp[0]) {
		//sp
		$(".tel-number").each(function(){
			if(!$(this).parent(".tel-wrap").length){
				const no = $(this).data("tel");
				$(this).wrap('<a href="tel:' + no + '" class="tel-wrap"></a>');
			}
		});
  } else if(w <= bp[1]){
		//tb
		$(".tel-wrap .tel-number").each(function(){
			$(this).unwrap();
		});
  } else if(w <= bp[2]){
		//small pc
  } else{
  
  }
}
//GoogleMapAPI
function googlemap(opt){
	const latlng = new google.maps.LatLng(opt.lat,opt.lng);
	const maplatlng = new google.maps.LatLng(opt.maplat,opt.maplng);
  const myOptions = {
    zoom: opt.zoom, /*拡大比率*/
    center: maplatlng, /*表示枠内の中心点*/
    tilt:0,
    styles:opt.styles,
    scrollwheel: false,
    mapTypeControl:false,
    mapTypeId: google.maps.MapTypeId.ROADMAP/*表示タイプの指定*/
  };
  const map = new google.maps.Map(document.getElementById(opt.wrapid), myOptions);
 
	/*アイコン設定▼*/
	const iconimage = {
		url:opt.icon,
		scaledSize : new google.maps.Size(opt.iconw,opt.iconh),
		origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(opt.iconw/2, opt.iconh/2)
	}
	
  const markerOptions = {
    position: latlng,
    map: map,
    title: opt.tit,
    icon:iconimage
  };
  const marker = new google.maps.Marker(markerOptions);
　/*アイコン設定ここまで▲*/

	/*情報ウィンドウ*/
  /*const contentString=opt.window;
  const infowindow=new google.maps.InfoWindow({
      content: contentString
  });
  if(opt.infoshow){
	  infowindow.open(map,marker);//表示
	}*/
  /* マーカーがクリックされた時に情報ウィンドウ表示 */
  /*google.maps.event.addListener(marker, 'click', function() {
    infowindow.open(map,marker);
  });*/
}

/*ブラウザ判別*/
function browserCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	const av = window.navigator.appVersion.toLowerCase();
	if(ua.indexOf('edge') != -1){
		return 'edge';
	}else if (ua.indexOf('opera') != -1) {
  	return 'opera';
	}else if (ua.indexOf("msie") != -1 || ua.indexOf("trident") != -1) {
		$("body").addClass('ie');
  	if (av.indexOf("msie 6.") != -1) {
    	return 'ie6';
  	} else if (av.indexOf("msie 7.") != -1) {
    	return 'ie7';
  	} else if (av.indexOf("msie 8.") != -1) {
    	return 'ie8';
  	} else if (av.indexOf("msie 9.") != -1) {
    	return 'ie9';
  	}else if (av.indexOf("msie 10.") != -1) {
    	return 'ie10';
  	}else if (av.indexOf("rv:11.") != -1) {
    	return 'ie11';
  	}
	} else if (ua.indexOf('chrome') != -1) {
  	return 'chrome';
	} else if (ua.indexOf('safari') != -1) {
  	return 'safari';
	} else if (ua.indexOf('gecko') != -1) {
  	return 'firefox';
	} else {
  	return false;
	}
}

/*OS判別*/
function osCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if (ua.indexOf('windows') != -1) {
		if(ua.indexOf('phone') != -1){
			return 'winphone';
		}else{
			return 'win';
		}
	}else if(ua.indexOf('iphone') != -1) {
		return 'iphone';
	}else if(ua.indexOf('ipad') != -1) {
		return 'ipad';
	}else if(ua.indexOf('mac') != -1) {
		return 'mac';
	}else if(ua.indexOf('android') != -1) {
		if(ua.indexOf('mobile') != -1){
			if(ua.indexOf('A1_07') != -1){
				return 'tablet';
			}else if(ua.indexOf('SC-01C') != -1){
				return 'tablet';
			}else{	return 'android';}
		}else{
			return 'tablet';
		}
	}else{
		return false;
	}
}

/*デバイス判別*/
function deviceCheck(){
	const ua = window.navigator.userAgent.toLowerCase();
	if((ua.indexOf("windows") != -1 && ua.indexOf("touch") != -1 && ua.indexOf("tablet pc") == -1) 
      || ua.indexOf("ipad") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") == -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("tablet") != -1)
      || ua.indexOf("kindle") != -1
      || ua.indexOf("silk") != -1
      || ua.indexOf("playbook") != -1){
      return 'tab';
    }else if((ua.indexOf("windows") != -1 && ua.indexOf("phone") != -1)
      || ua.indexOf("iphone") != -1
      || ua.indexOf("ipod") != -1
      || (ua.indexOf("android") != -1 && ua.indexOf("mobile") != -1)
      || (ua.indexOf("firefox") != -1 && ua.indexOf("mobile") != -1)
      || ua.indexOf("blackberry") != -1){
	    return 'sp';
    }else{
      return 'pc';
    }
}